import { IArrematacao, IArrematacaoListagemResumo } from '../interfaces/IArrematacao';

/**
 * Organiza as arrematações de uma declaração para ser exibida no resumo
 *
 * @param arrematacoes Arrematações de uma declaração
 * @returns {IArrematacaoListagemResumo} Arrematações listadas de forma resumida
 */
export const arrematacoesTotais = (arrematacoes: IArrematacao[]) => {
  const novaListagemData: IArrematacaoListagemResumo[] = [];
  arrematacoes.forEach((arrematacao) => {
    const indiceListagem = novaListagemData.findIndex(
      (item) =>
        item.numeroProcesso === arrematacao.numeroProcesso &&
        item.municipio.codigoIBGE === arrematacao.municipio.codigoIBGE &&
        item.substancia === arrematacao.substancia
    );
    if (indiceListagem === -1) {
      novaListagemData.push({
        numeroProcesso: arrematacao?.numeroProcesso || '',
        municipio: arrematacao.municipio,
        substancia: arrematacao.substancia,
        arrematacao: arrematacao,
        totais: {
          valorTotalDeOperacao: arrematacao.componenteBaseDeCalculo.codigosNCM
            .reduce((acumulador, item) => {
              return acumulador + parseFloat(item.valor);
            }, 0)
            .toString(),
          quantidadeTotal: arrematacao.componenteBaseDeCalculo.codigosNCM.reduce((acumulador, item) => {
            return acumulador + parseFloat(item.quantidade);
          }, 0),
        },
      });
    } else {
      const valorOperacao = parseFloat(novaListagemData[indiceListagem].totais.valorTotalDeOperacao);
      const quantidade = novaListagemData[indiceListagem].totais.quantidadeTotal;

      novaListagemData[indiceListagem].totais.valorTotalDeOperacao = arrematacao.componenteBaseDeCalculo.codigosNCM
        .reduce((acumulador, item) => {
          return acumulador + parseFloat(item.valor);
        }, valorOperacao)
        .toString();

      novaListagemData[indiceListagem].totais.quantidadeTotal = arrematacao.componenteBaseDeCalculo.codigosNCM.reduce(
        (acumulador, item) => {
          return acumulador + parseFloat(item.quantidade);
        },
        quantidade
      );
    }
  });
  return novaListagemData;
};
